import { useUser } from "@clerk/clerk-expo";
import { useExams } from "@features/exam";
import { QAChatWrapper } from "@features/session";
import { isWeb } from "@helpers/platform";
import { Box } from "@memorang/ui";
import ModalHeader from "components/ModalHeader";
import { Redirect, Stack, usePathname } from "expo-router";
import { useTranslation } from "react-i18next";

export default function Layout() {
	const { isSignedIn, isLoaded } = useUser();
	useExams();

	const pathname = usePathname();

	const { t } = useTranslation();

	if (!isLoaded) {
		return null;
	}
	if (!isSignedIn && pathname !== "/redeem") {
		return <Redirect href="/(auth)/login" />;
	}
	return (
		<Box flex={1} flexDirection="row" justifyContent="space-between">
			<Stack
				screenOptions={{
					headerShown: false,
					contentStyle: {
						flex: 1,
					},
				}}
			>
				<Stack.Screen
					name="(tabs)"
					options={{
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="purchase/index"
					options={{
						presentation: "modal",
						headerShown: true,
						header: () => <ModalHeader />,
					}}
				/>
				<Stack.Screen
					name="session/customize"
					options={{
						presentation: "modal",
						headerShown: true,
						animationDuration: 0,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle={t("sessionConfig.title")}
							/>
						),
					}}
				/>
				<Stack.Screen
					name="suggestcorrection"
					options={{
						presentation: "modal",
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="stimulus"
					options={{
						presentation: "modal",
						headerShown: false,
						header: () => <ModalHeader />,
					}}
				/>
				<Stack.Screen
					name="profile/change-avatar"
					options={{
						presentation: "modal",
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle="Choose your avatar"
							/>
						),
					}}
				/>
				<Stack.Screen
					name="feedback"
					options={{
						presentation: "modal",
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="exams"
					options={{
						presentation: "modal",
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="aila/[itemId]"
					options={{
						presentation: "modal",
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="faqs"
					options={{
						presentation: "modal",
						headerShown: false,
					}}
				/>
			</Stack>
			{isWeb && pathname !== "/onboarding" && <QAChatWrapper />}
		</Box>
	);
}
